// extracted by mini-css-extract-plugin
module.exports = {"root":"SocialShare_root__MfJHG","inverted":"SocialShare_inverted__2wjlm","shareButton":"SocialShare_shareButton__71Z_2"};